import { render } from "./companySlide.vue?vue&type=template&id=02f3713c&scoped=true"
import script from "./companySlide.vue?vue&type=script&lang=js"
export * from "./companySlide.vue?vue&type=script&lang=js"

import "./companySlide.vue?vue&type=style&index=0&id=02f3713c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f3713c"]])

export default __exports__